import { useEffect, useState } from "react";

import { InviteList } from "@/components/InvitationDialogStacks/InviteList";
import { useCurrentUser } from "@/queries/users";
import { useGetWorkspaceInvites } from "@/queries/workspace";

export const InvitationDialogStacks = () => {
  const user = useCurrentUser();
  const currentUserInvites = useGetWorkspaceInvites({
    invitee_email: user.data?.email,
  });
  const [isOpen, setIsOpen] = useState(false);
  const invites = currentUserInvites.data?.items || [];

  useEffect(() => {
    if (!user.isLoading || (!currentUserInvites.isFetching && invites.length > 0)) {
      setIsOpen(true);
    }
  }, [user.isLoading, currentUserInvites.isFetching, invites.length]);

  return <InviteList invites={invites} isOpen={isOpen} setIsOpen={setIsOpen} />;
};
